import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Dialog, DialogTitle, DialogActions, Button,
} from '@material-ui/core';

import {
  DateRangePicker, DateRangeStepper,
} from '../../../components';
import FilterWrapper from '../filter-wrapper';

const styles = {
  dateRangePicker: {
    width: '100%',
  },
};

const FUTURE_DATE_MESSAGE_TYPE = 'futureDate';

class DateRangeFilter extends Component {
  constructor(props) {
    super(props);

    const nextDay = moment().add(1, 'days').set('hours', 5).set('minutes', 0)
      .startOf('minutes')
      .unix();

    this.state = {
      futeDateWarningOpen: props.dateRange.startDate >= nextDay,
    };
  }

  componentDidUpdate(prevProps) {
    const { dateRange: oldDateRange } = prevProps;
    const { dateRange: newDateRange, removeMessagesByType } = this.props;

    const nextDay = moment().add(1, 'days').set('hours', 5).set('minutes', 0)
      .startOf('minutes')
      .unix();

    if (oldDateRange.startDate < nextDay && newDateRange.startDate >= nextDay) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        futeDateWarningOpen: true,
      });
    } else if (oldDateRange.startDate >= nextDay && newDateRange.startDate < nextDay) {
      removeMessagesByType(FUTURE_DATE_MESSAGE_TYPE);
    }
  }

  handleClose = () => {
    const { addMessage } = this.props;

    this.setState({
      futeDateWarningOpen: false,
    });
    addMessage({
      message: 'Datum liegt in der Zukunft, Vorjahreswerte werden visualisiert!',
      type: FUTURE_DATE_MESSAGE_TYPE,
      level: 'warning',
    });
  }

  renderSuggestComparisonDialog = () => {
    const { futeDateWarningOpen } = this.state;

    return (
      <Dialog
        open={futeDateWarningOpen}
        onClose={this.handleClose}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle id="form-dialog-title" style={styles.dialogTitle}>
        Datum liegt in der Zukunft, Vorjahreswerte werden visualisiert!
        </DialogTitle>
        <DialogActions>
          <Button onClick={this.handleClose}>
              Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }


  render() {
    const {
      isAdvancedFilter, dateRange, setDateRange,
    } = this.props;

    const title = 'Von - Bis';

    return (
      <FilterWrapper title={title} height={1.5} isAdvancedFilter={isAdvancedFilter}>
        <DateRangePicker
          startDate={moment.unix(dateRange.startDate)}
          endDate={moment.unix(dateRange.endDate)}
          onDatesChanged={setDateRange}
          styles={styles.dateRangePicker}
          title={title}
        />
        <DateRangeStepper
          startDate={moment.unix(dateRange.startDate)}
          endDate={moment.unix(dateRange.endDate)}
          onDatesChanged={setDateRange}
        />
        {this.renderSuggestComparisonDialog()}
      </FilterWrapper>
    );
  }
}

DateRangeFilter.propTypes = {
  isAdvancedFilter: PropTypes.bool,
  dateRange: PropTypes.object,
  setDateRange: PropTypes.func,
  addMessage: PropTypes.func,
  removeMessagesByType: PropTypes.func,
};

DateRangeFilter.defaultProps = {
  isAdvancedFilter: false,
  dateRange: {
    startDate: 0,
    endDate: 0,
  },
  setDateRange: () => {},
  addMessage: () => {},
  removeMessagesByType: () => {},
};

export default DateRangeFilter;
